import { render, staticRenderFns } from "./BlockAdditional.vue?vue&type=template&id=0251fec5&scoped=true"
import script from "./BlockAdditional.vue?vue&type=script&lang=js"
export * from "./BlockAdditional.vue?vue&type=script&lang=js"
import style0 from "./BlockAdditional.vue?vue&type=style&index=0&id=0251fec5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0251fec5",
  null
  
)

export default component.exports